import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../assets/css/font.css'
import '../assets/css/global.css'
import BlockUi from 'react-block-ui'
import 'react-block-ui/style.css'
import styled from 'styled-components'
import { ProjectName, Login, Favicon } from '../assets'
import MessageLogin from '../components/MessageLogin'
import MessagePassword from '../components/MessagePassword'
import BannerCookies from '../components/BannerCookies'
export const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${(props) =>
        props.overlay
            ? `${Login.form.gradientRGB}, url(${Login.backgroundImage}) no-repeat center`
            : `url(${Login.backgroundImage}) no-repeat center`};
    height: initial;
    min-height: 100vh;
    background-size: cover;
    @media screen and (max-width: 992px) {
        min-height: 212px;
    }
`
export const ContentBannersBottom = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
`

export const InfoWrapper = styled.div`
    max-width: 450px;
    font-size: 32px;
`

export const InfoContainer = styled.div`
    width: 100%;
    color: ${Login.textColor};
    font-size: 18px;
    font-weight: normal;
    @media screen and (max-width: 992px) {
        padding: 2rem;
        font-size: 0.875rem;
    }
`

export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon-container {
        /* margin-top: 115px; */
    }
    @media screen and (max-width: 992px) {
        height: 100%;
    }
`

const PublicLayout = ({ children, blocking, showPasswordInfo, showLogin, showForgotPass }) => {
    //--- isMobile ---
    const [width, setWidth] = useState(window.innerWidth)
    const [isMobile, setIsMobile] = useState(false)
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth)
    }
    useEffect(() => {
        setIsMobile(width <= 992)
    }, [width])
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange)
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange)
        }
    }, [])

    return (
        <div id="page-wrap" className="wrapper">
            <Helmet
                title={ProjectName}
                meta={[
                    { name: 'description', content: ProjectName },
                    {
                        name: 'keywords',
                        content: 'prefacturas, pagos, comercios, establecimientos, vendedores'
                    },
                    {
                        name: 'viewport',
                        content:
                            'width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1, user-scalable=0'
                    }
                ]}
                link={[
                    {
                        rel: 'shortcut icon',
                        type: 'image/x-icon',
                        href: `${Favicon}`
                    }
                ]}
            />
            <BlockUi tag="div" blocking={blocking}>
                <div id="page-wrap" className="row">
                    <ImageContainer className="col-lg-6 col-md-12" overlay={showPasswordInfo}>
                        <InfoWrapper>
                            <InfoContainer>
                                {showPasswordInfo && <MessagePassword isMobile={isMobile} />}
                                {showLogin && isMobile && <MessageLogin />}
                                {showForgotPass && isMobile && <h3>Olvidé mi contraseña</h3>}
                            </InfoContainer>
                        </InfoWrapper>
                    </ImageContainer>
                    <FormWrapper className="col-lg-6 col-md-12">{children}</FormWrapper>
                </div>
            </BlockUi>
            <ContentBannersBottom>
                <BannerCookies />
            </ContentBannersBottom>
        </div>
    )
}

PublicLayout.propTypes = {
    blocking: PropTypes.bool,
    showPasswordInfo: PropTypes.bool
}

PublicLayout.defaultProps = {
    blocking: false,
    showPasswordInfo: false
}

export default PublicLayout
